import Vue from 'vue';
import store from './store'
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import Multiselect from 'vue-multiselect'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircleNotch, faExternalLinkAlt, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import router from './router'
import Title from './components/fidelior-title';
import Areas from './components/fidelior-areas';
import Role from './components/fidelior-role';
import { AgGridVue } from "ag-grid-vue";
 
library.add(faCircleNotch, faExternalLinkAlt, faUser);
 
Vue.component('multiselect', Multiselect)
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('ag-grid-vue', AgGridVue);
Vue.component('fidelior-title', Title);
Vue.component('fidelior-areas', Areas);
Vue.component('fidelior-role', Role);

Vue.use(BootstrapVue);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');